<template>
  <CCard>
    <CCardBody>
      <CForm>
        <CAlert
          color="danger"
          id="aviso"
          name="aviso"
          :show.sync="validacoes.aviso"
          closeButton
          >{{ validacoes.msg }}</CAlert
        >
        <CAlert
          color="success"
          id="sucesso"
          name="sucesso"
          :show.sync="validacoes.sucesso"
          closeButton
          >{{ validacoes.msg }}</CAlert
        >
        <CTabs>
          <CTab>
            <CModal
              class="modal-excluir-consulta"
              :show.sync="modalDesativarCadastro"
            >
              <div class="div-body-modal">
                <img
                  src="../../assets/atencao.jpg"
                  width="120px"
                  height="120px"
                  alt=""
                />
                <h4>{{ title_modal }}</h4>
                <p>{{ text_modal }}</p>

                <button
                  type="button"
                  @click="desativarCadastro()"
                  v-show="btnDesativarCadastro"
                >
                  DESATIVAR
                </button>
                <button
                  type="button"
                  class="btn-modal"
                  @click="modalDesativarCadastro = false"
                  v-show="btnCancelarDesativacao"
                >
                  CANCELAR
                </button>
              </div>
            </CModal>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Dados de Cadastro
            </template>
            <br />
            <CSelect
              :value.sync="cadastro.typeUser"
              :options="tipoAcesso"
              prepend="ACESSO"
              invalid-feedback="* Campo obrigatório"
              placeholder="Tipo de Acesso"
            >
              <template #append-content>
                <CIcon name="cil-badge" />
              </template>
            </CSelect>

            <CInput
              type="text"
              v-model="cadastro.username"
              prepend="EMAIL"
              autocomplete="complemento"
              invalid-feedback="Convenio obrigatorio"
              @change="validarUsername"
            >
              <template #append-content>
                <CIcon name="cil-contact" />
              </template>
            </CInput>
            <label for=""
              >Senha (mínimo 6 caracteres contendo letras, números e um caractere espcial)</label
            >
            <CInput
              type="password"
              v-model="cadastro.password"
              autocomplete="complemento"
              invalid-feedback="* Campo obrigatorio"
              @input="validarSenha"
            >
            </CInput>
            <p class="red" v-for="(item,index) of erros" :key="index">{{ item }}</p>
            <label for="">Confirme sua senha</label>
            <CInput
              type="password"
              v-model="cadastro.repeatPassword"
              autocomplete="complemento"
              invalid-feedback="* Campo obrigatorio"
            >
            </CInput>

            <CAlert
              color="danger"
              id="aviso"
              name="aviso"
              :show.sync="validacoes.aviso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >
            <CAlert
              color="success"
              id="sucesso"
              name="sucesso"
              :show.sync="validacoes.sucesso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >

            <CButton color="success" class="m-2" @click="cadastrarAcesso()"
              >Cadastrar</CButton
            >
            <CButton color="info" class="m-2" @click="voltar()">Voltar</CButton>
          </CTab>
        </CTabs>
      </CForm>
    </CCardBody>
    <CCardBody>
      <CDataTable
        :items="registers"
        :fields="fields"
        :noItemsView="not_found"
        column-filter
        hover
        searching
        sorter
        small
        :fixed="fixed"
        :items-per-page="10"
        :dark="dark"
        pagination
      >
        <template #acao="{ item, index }">
          <td class="py-4">
            <CButton
              color="danger"
              variant="outline"
              square
              size="sm"
              @click="desativarCadastroModal(item, index)"
              >DESATIVAR</CButton
            >
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>
<script>
export default {
  data() {
    return {
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      modalDesativarCadastro: false,
      btnDesativarCadastro: false,
      btnCancelarDesativacao: false,
      title_modal: "",
      text_modal: "",
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },
      fields: [
        { key: "username", label: "Usuário", _style: "min-width:200px" },
        { key: "name", label: "Nome", _style: "min-width:200px" },
        {
          key: "occupation",
          label: "Tipo de Acesso",
          _style: "min-width:100px;",
        },
        {
          key: "acao",
          label: "",
          sorter: false,
          filter: false,
        },
      ],
      tipoAcesso: [
        {
          label: "Administrador",
          value: 1,
        },
        {
          label: "Recepcionista",
          value: 3,
        },
      ],

      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
        statusDados: false,
      },
      cadastro: {
        username: "",
        password: "",
        typeUser: "",
        repeatPassword: "",
      },
      items: [],
      registers: [],
      idCadastro: "",
      erros:[]
    };
  },
  methods: {
    voltar() {
      this.$router.push("/dashboard");
    },
    listarCadastros() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}cadastros`)
        .then((res) => res.json())
        .then((res) => {
          this.items = res;
        });
    },
    validarUsername() {
      let arrItems = this.items;
      arrItems.forEach((item) => {
        if (item.username === this.cadastro.username) {
          this.validacoes.msg = "Endereço de email já cadastrado";
          this.validacoes.aviso = true;
          this.cadastro.username = "";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      });
    },
    validarCampos() {
      let arrDadosCadastro = Object.values(this.cadastro);
      const expLogin = /[^\n]+@\S+\.\S+/;
      const regex = /^(?=.*\d)(?=.*[a-z])[0-9a-zA]{6,}$/;
      arrDadosCadastro.forEach((item) => {
        if (item) {
          if (expLogin.test(this.cadastro.username)) {

            if(this.erros.length > 0){
              this.validacoes.aviso = true;
                this.validacoes.msg = "Senha inválida";
                this.cadastro.repeatPassword = "";
            }
          } else {
            this.validacoes.aviso = true;
            this.validacoes.msg = "Insira um endereço de email válido";
            this.cadastro.username = "";
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 3000);
          }
        } else {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Preencha todos os campos corretamente";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      });
    },
    postCadastro() {
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}cadastro-login`, {
          typeUser: this.cadastro.typeUser,
          username: this.cadastro.username,
          password: this.cadastro.password,
          secret: this.cadastro.secret,
        })
        .then((res) => res.json())
        .then((res) => {
          this.cadastro = "";
          this.validacoes.msg = "Cadastro efetuado com sucesso";
          this.validacoes.sucesso = true;
          setTimeout(() => {
            this.validacoes.sucesso = false;
          }, 3000);
        });
    },
    cadastrarAcesso() {
      
      this.validarCampos();

      if (!this.validacoes.aviso) {
        this.postCadastro();
      }
    },
    listRegisterUsers() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}cadastros`)
        .then((res) => res.json())
        .then((res) => {
          this.registers = res;
          this.registers.forEach((item) => {
            if (!item.name) {
              item.name = "-";
            }
          });
        });
    },
    desativarCadastroModal(item) {
      this.idCadastro = item.id;
      this.modalDesativarCadastro = true;
      this.btnDesativarCadastro = true;
      this.btnCancelarDesativacao = true;
      this.text_modal = "Tem certeza que deseja desativar este cadastro?";
      this.title_modal = "ATENÇÃO";
    },
    desativarCadastro() {
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}desativar-cadastro/${this.idCadastro}`
        )
        .then((res) => res.json())
        .then((res) => {
          this.modalDesativarCadastro = false;
          this.listRegisterUsers();
        });
    },
    validarSenha() {
      this.erros = []
      const senha = this.cadastro.password;
      const hasUppercase = /[A-Z]/.test(senha);
      const hasSpecialChar = /[^a-zA-Z0-9]/.test(senha);
      const hasLettersAndNumbers =
        /[a-zA-Z]/.test(senha) && /[0-9]/.test(senha);

      if(senha.length < 6){
        this.erros.push("A senha deve ter 6 ou mais caracteres.");
      }
      if (!hasUppercase) {
        this.erros.push("A senha deve conter pelo menos uma letra maiúscula.");
      }

      if (!hasSpecialChar) {
        this.erros.push("A senha deve conter pelo menos um caractere especial.");
      }

      if (!hasLettersAndNumbers) {
        this.erros.push("A senha deve conter letras e números.");
      }

      if (this.erros.length > 0) {
        // Exibir alertas de erro
        for (let erro of this.erros) {
          console.log(erro);
        }
      } else {
        // A senha atende aos critérios de validação
        console.log("A senha é válida");
      }
    },
  },

  mounted() {
    this.listRegisterUsers();
    this.listarCadastros();
  },
};
</script>
<style>
.pb-4,
.py-4 {
  padding: 10px !important;
}
.red{
  color: red;
  margin-bottom: 0px;
}
</style>
